<template>
   <div>
      <h6 data-testid="doc-conf-title" class="heading-small text-muted mb-4 text-truncate">Configure {{documentName}} - {{currentDocumentTypeCode}} </h6>
      <form id="form-proper">
          <base-input data-testid="doc-conf-document-name" id="doc-conf-document-name" alternative="" label="Document Name" disabled placeholder="" v-model="documentName" input-classes="form-control" />
          <base-input data-testid="doc-conf-friendly-code" alternative="" label="Friendly Code" disabled placeholder="" v-model="documentFriendlyCode" input-classes="form-control" />
          <hr class="my-3">
          <label class="form-control-label">
            Additional Configuration
          </label>
 
          <a-tabs defaultActiveKey="1" tabPosition="top">
            <a-tab-pane data-testid="doc-conf-pricecost-tab" tab="Price or Cost" key="1">
              <p style="line-height: 90%;"><small>During transaction, system automatically picks up a price when a product is identified. Please select which price or cost do you want the system to use</small></p>
              <div class="col">
                <a-select data-testid="doc-conf-pricecost-select" style="width: 100%" :value="priceOrCost" @change="changePriceOrCost">
                  <a-select-option v-for="option in filteredPriceCostOptions" v-bind:key="option">{{option}}</a-select-option>
                </a-select>
              </div>
            </a-tab-pane>
 
            <a-tab-pane tab="Reference Captions" key="2">
              <p style="line-height: 90%;"><small>References are extra codes that you can use to store additional information.</small></p>
 
              <div class="row">
                <div class="col text-center">
                  <small>Reference Name</small>
                </div>
                <div class="col text-center">
                  <small>Reference Values</small>
                </div>
                <div class="col text-center">
                  <small>Allow duplicate values?</small>
                </div>
              </div>
 
              <div v-for="(reference, index) in references" v-bind:key="'references'+index" class="row pt-2">
                <div class="col text-center">
                  <a-input :data-testid="'reference-name-'+index+'-input'" :placeholder="reference.name" v-model="reference.name" />
                </div>
                <div class="col text-center">
                  <a-input :data-testid="'reference-value-'+index+'-input'" placeholder="values" v-model="reference.value" />
                </div>
                <div class="col text-center">
                  <base-checkbox :data-testid="'reference-duplicate-'+index+'-checkbox'" v-model="reference.duplicate"></base-checkbox>
                </div>
              </div>
            </a-tab-pane>
 
            <a-tab-pane tab="Editor Behavior" key="3">
              <div class="row mx-0">
                <p style="line-height: 90%;"><small>In some cases, you may want to restrict user from entering too many lines per document or transaction</small></p>
              </div>
              <div class="row mx-0">
                <div class='col'>
                  <base-checkbox class='pt-2' :data-testid="'line-restriction-checkbox'" v-model='editorBehavior.lineRestrictionCheckbox' @change='toggleLineRestrictionCheckbox'>Restrict maximum number of lines</base-checkbox>
                </div>
                <div class='col-auto'>
                  <a-input type="number" :data-testid="'line-restriction-input'" style="width: 100%" :min="1" v-model='editorBehavior.lineRestrictionInput' placeholder='lines' :disabled="editorBehavior.lineRestrictionCheckboxIsDisabled"/>
                </div>
              </div>
              <div class="row mx-0">
                <div class="col-md-12 col-lg-12 col-sm-12 col-xs-12 p-0  mt-3">
                  <p v-if="currentDocumentTypeCode == 'OTHPCN'" style="line-height: 90%;"><small>Input allowed number of item lines in csv when mass uploading of products and maximum of 2000.</small></p>
                  <p v-else style="line-height: 90%;"><small>Input allowed number of item lines in csv when mass uploading of products</small></p>
                </div>
                <div class="col-lg-3 col-md-3 col-xs-3 ">
                  <a-input type="number" style="width: 100%" :min="1" :data-testid="'max-mass-upload-line-restriction-input'" v-model='editorBehavior.maxMassUploadLineRestrictionInput' placeholder='lines'/>
                </div>
              </div>
              <p class='mb-0 mt-3'><small>Encoding Behavior</small></p>
              <div class="row mx-0">
                <a-radio-group :data-testid="'encoding-behavior-radio'" defaultValue="S" v-model="editorBehavior.radio">
                  <a-radio value="S">Standard - Do not allow duplicate product</a-radio> <br>
                  <a-radio value="L">Linear - Allow duplicate entries</a-radio> <br>
                  <a-radio value="P">POS - Quantity entered is added to previous quantity</a-radio>
                </a-radio-group>
              </div>
              <p class='mb-0 mt-3'><small>Prefix Search</small></p>
              <div class="row mx-0">
                <a-select :data-testid="'prefix-search-select'" style="width: 100%" v-model="editorBehavior.prefixSearch" allowClear>
                  <a-select-option v-for="option in prefixSearchOption" :key="option.value">{{option.name}}</a-select-option>
                </a-select>
              </div>
              <p class='mb-0 mt-3'><small>Revenue Crediting Mode</small></p>
              <div class="row mx-0">
                <a-select :data-testid="'revenue-crediting-mode-select'" style="width: 100%" v-model="editorBehavior.revenueCreditingMode">
                  <a-select-option v-for="option in revenueCreditingModeOption" :key="option.value">{{option.name}}</a-select-option>
                </a-select>
              </div>
 
            </a-tab-pane>
 
            <a-tab-pane tab="Additional Editor Behavior" key="4">
              <p style="line-height: 90%;"><small>Here are more behavior which you may configure</small></p>
              <div class="row" v-if="['ORIPOX', 'ORITRQ'].includes(currentDocumentTypeCode)">
                <div class="col-7 pt-1">
                  Number of days for offtake based auto-replenishment:
                </div>
                <div class="col-3">
                  <a-input type="number" :data-testid="'offtake-days-input'" style="width: 100%" :min="1" v-model='additionalEditorBehavior.offtakeDays' placeholder='days'/>
                </div>
              </div>

              <!-- Stock Request Cut-Off Time -->
              <div v-if="['OROTRQ', 'ORITRQ'].includes(currentDocumentTypeCode)" style="border-top: 1px solid #e9ecef; margin-top: 16px; padding-top: 16px;">
                <div class="row align-items-center">
                  <div class="col-9">
                    Enable Stock Request Cut-Off Time
                  </div>
                  <div class="col-3 text-right">
                    <a-switch :data-testid="'enable-stock-request-cutoff-switch'" v-model="additionalEditorBehavior.enableStockRequestCutOff" />
                  </div>
                </div>
                <div v-if="additionalEditorBehavior.enableStockRequestCutOff" class="pl-3 pt-3">
                  <div class="row align-items-center">
                    <div class="col-4 pt-1">Cut-Off Time:</div>
                    <div class="col-6">
                      <a-time-picker
                        :data-testid="'stock-request-cutoff-time-picker'"
                        style="width: 100%"
                        use12Hours
                        format="hh:mm A"
                        placeholder="Select cut-off time"
                        :value="cutOffTimeMoment"
                        @change="onCutOffTimeChange" />
                    </div>
                  </div>
                  <div class="row align-items-center pt-3">
                    <div class="col-4 pt-1">Behavior after cut-off:</div>
                    <div class="col-6">
                      <select :data-testid="'stock-request-cutoff-behavior-select'" class="form-control form-control-sm" v-model="additionalEditorBehavior.stockRequestCutOffBehavior">
                        <option value="warn">Warn only</option>
                        <option value="disable">Disable document posting</option>
                      </select>
                    </div>
                  </div>
                  <div class="row pt-2">
                    <div class="col-12">
                      <small style="color: #7b7fd4;">Requests created after the cut-off time will follow the selected behavior. Applies to this document type.</small>
                    </div>
                  </div>
                </div>
              </div>
              <ul style="list-style-type:none" class='p-0'>
                <li v-if='currentDocumentTypeCode.includes("REC")'><base-checkbox :data-testid="'restrict-rec-of-cost-equal-or-higher-retail-price-checkbox'" v-model="additionalEditorBehaviorCheckboxes.restrictRecOfCostEqualOrHigherRetailPrice">Restrict receiving of cost equal to or higher than retail price</base-checkbox></li>
                <li v-if='currentDocumentTypeCode=="OROTRQ" || currentDocumentTypeCode=="OROCSQ" || currentDocumentTypeCode=="RECDEL" || currentDocumentTypeCode=="ORIPOX" || currentDocumentTypeCode=="RECTRX" || currentDocumentTypeCode=="RELTRX"'><base-checkbox data-testid="restrict-without-origin-doc" v-model="additionalEditorBehaviorCheckboxes.restrictWithoutOriginDoc">Restrict creating document without origin document</base-checkbox></li>
                <li v-if='currentDocumentTypeCode=="RECDEL" || currentDocumentTypeCode=="RELRSR" || currentDocumentTypeCode=="ORIPOX"'><base-checkbox :data-testid="'filter-product-by-supplier-checkbox'" v-model="additionalEditorBehaviorCheckboxes.filterProductBySupplier">Filter product by supplier</base-checkbox></li>
                <li ><base-checkbox :data-testid="'confirm-document-status-checkbox'" v-model="additionalEditorBehaviorCheckboxes.confirmDocumentStatus">Enable confirmed/unconfirmed document status</base-checkbox></li>
                <li v-if='currentDocumentTypeCode=="RECDEL" || currentDocumentTypeCode=="RECTRX"'><base-checkbox :data-testid="'update-last-arrival-date-when-posted-checkbox'" v-model="additionalEditorBehaviorCheckboxes.updateLastArrivalDateWhenPosted">Update products's last arrival date when posted</base-checkbox></li>
                <li v-if='currentDocumentTypeCode=="RECDEL" || currentDocumentTypeCode=="RECTRX"'><base-checkbox :data-testid="'update-last-arrival-quantity-when-posted-checkbox'" v-model="additionalEditorBehaviorCheckboxes.updateLastArrivalQuantityWhenPosted">Update products's last arrival quantity when posted</base-checkbox></li>
                <li v-if='currentDocumentTypeCode=="RECDEL" || currentDocumentTypeCode=="RECTRX"'><base-checkbox :data-testid="'update-last-arrival-supplier-when-posted-checkbox'" v-model="additionalEditorBehaviorCheckboxes.updateLastArrivalSupplierWhenPosted">Update products's last arrival supplier when posted</base-checkbox></li>
                <li><base-checkbox :data-testid="'item-desc-edit-for-printing-checkbox'" v-model="additionalEditorBehaviorCheckboxes.itemDescEditForPrinting">Allow editing of item description for printing purposes</base-checkbox></li>
                <!-- <li v-if='currentDocumentTypeCode!="ORIPOX" && currentDocumentTypeCode!="ORIASN" && currentDocumentTypeCode!="RECDEL"'><a-checkbox v-model="additionalEditorBehaviorCheckboxes.enableAddCharges">Enable add charges</a-checkbox></li> -->
                <li v-if='currentDocumentTypeCode=="ORISOX" || currentDocumentTypeCode=="RECDEL"'><base-checkbox :data-testid="'enable-add-charges-checkbox'" v-model="additionalEditorBehaviorCheckboxes.enableAddCharges">Enable add charges</base-checkbox></li>
                <li v-if='currentDocumentTypeCode=="RECDEL" || currentDocumentTypeCode=="ORIPOX"'><base-checkbox :data-testid="'package-default-item-encoding-checkbox'" v-model="additionalEditorBehaviorCheckboxes.packageDefaultItemEncoding">Use package as default item in encoding</base-checkbox></li>
                <li v-if='currentDocumentTypeCode=="RECDEL" || currentDocumentTypeCode=="ORIPOX"'><base-checkbox :data-testid="'show-vat-exclusive-amount-checkbox'" v-model="additionalEditorBehaviorCheckboxes.showVatExclusiveAmount">Enable showing VAT-exclusive amounts in document</base-checkbox></li>
                <li><base-checkbox :data-testid="'audit-trail-checkbox'" v-model="additionalEditorBehaviorCheckboxes.auditTrail">Enable audit trail</base-checkbox></li>
                <li v-if="['OROTRQ', 'OROCSQ', 'ORITRQ', 'ORICSQ', 'RECTRX', 'RELTRX', 'OTHPUR', 'ORIPOX', 'RECDEL', 'RELRSR', 'ORITRQ', 'OROTRQ', 'RECTRX', 'RELTRX'].includes(currentDocumentTypeCode)"><base-checkbox v-model="additionalEditorBehaviorCheckboxes.termsAndDiscount">Hide terms and discount in document editor</base-checkbox></li>
                <li v-if='currentDocumentTypeCode=="RECDEL"'><base-checkbox :data-testid="'show-po-balance-quantity-with-color-coding-checkbox'" v-model="additionalEditorBehaviorCheckboxes.showPoBalanceQuantityWithColorCoding">Show PO balance quantity with color coding</base-checkbox></li>
                <li v-if='currentDocumentTypeCode=="RECTRX" || currentDocumentTypeCode=="RELTRX"'><base-checkbox :data-testid="'restrict-back-dating-in-documents-checkbox'" v-model="additionalEditorBehaviorCheckboxes.restrictBackDatingInDocuments">Restrict back dating of date in documents</base-checkbox></li>
                <li><base-checkbox :data-testid="'four-decimal-places-checkbox'" v-model="additionalEditorBehaviorCheckboxes.fourDecimalPlaces">Allow four (4) decimal places in subtotal</base-checkbox></li>
                <li v-if='currentDocumentTypeCode=="ORISOX"'><base-checkbox :data-testid="'allow-promotion-computation-checkbox'" v-model="additionalEditorBehaviorCheckboxes.allowPromotionComputation">Allow promotion computation</base-checkbox></li>
                <li v-if='currentDocumentTypeCode=="ORISOX" || currentDocumentTypeCode=="OTHSIN"'><base-checkbox :data-testid="'automatic-posting-on-save-checkbox'" v-model="additionalEditorBehaviorCheckboxes.automaticPostingOnSave">Automatic posting on save</base-checkbox></li>
                <li v-if='currentDocumentTypeCode=="ORISOX" || currentDocumentTypeCode=="RELDDE" || currentDocumentTypeCode=="OTHSIN"'><base-checkbox :data-testid="'allow-payment-on-posting-checkbox'" v-model="additionalEditorBehaviorCheckboxes.allowPaymentOnPosting">Allow payment on posting</base-checkbox></li>
                <li v-if='currentDocumentTypeCode=="ORIPOX"'><base-checkbox :data-testid="'enable-recording-of-initial-deposit-checkbox'" v-model="additionalEditorBehaviorCheckboxes.enableRecordingOfInitialDeposit">Enable Recording of Initial Deposit on posting</base-checkbox></li>
                <li v-if='currentDocumentTypeCode=="RELDDE"'><base-checkbox :data-testid="'allow-creation-of-dd-without-so-checkbox'" v-model="additionalEditorBehaviorCheckboxes.allowCreationOfDDWithoutSO">Allow Creation of DD without SO</base-checkbox></li>
                <li v-if='currentDocumentTypeCode=="RELDDE"'><base-checkbox :data-testid="'auto-create-sales-invoice-on-posting-checkbox'" @change="checkAutocreationOfSI(additionalEditorBehaviorCheckboxes.autoCreateSalesInvoiceOnPosting,'create')" v-model="additionalEditorBehaviorCheckboxes.autoCreateSalesInvoiceOnPosting">Auto create Sales Invoice on posting</base-checkbox></li>
                <li v-if='currentDocumentTypeCode=="RELDDE"'><base-checkbox :data-testid="'auto-create-and-post-sales-invoice-on-posting-checkbox'" @change="checkAutocreationOfSI(additionalEditorBehaviorCheckboxes.autoCreateAndPostSalesInvoiceOnPosting,'create&post')" v-model="additionalEditorBehaviorCheckboxes.autoCreateAndPostSalesInvoiceOnPosting">Auto create and post Sales Invoice on posting</base-checkbox></li>
                <li v-if='currentDocumentTypeCode=="RECTRX" || currentDocumentTypeCode=="RELTRX" || currentDocumentTypeCode=="OTHTRA" || currentDocumentTypeCode=="ORIPOX" || currentDocumentTypeCode=="RECDEL" || currentDocumentTypeCode=="RECADJ" || currentDocumentTypeCode=="RELADJ" || currentDocumentTypeCode=="ORISOX" || currentDocumentTypeCode=="RELDDE"'><base-checkbox :data-testid="'display-all-references-checkbox'" v-model="additionalEditorBehaviorCheckboxes.displayAllReferences">Display all references</base-checkbox></li>
                <li v-if='currentDocumentTypeCode=="RECTRX" || currentDocumentTypeCode=="RELTRX" || currentDocumentTypeCode=="OTHTRA" || currentDocumentTypeCode=="ORIPOX" || currentDocumentTypeCode=="RECDEL" || currentDocumentTypeCode=="RECADJ" || currentDocumentTypeCode=="RELADJ"'><base-checkbox :data-testid="'display-total-quantity-checkbox'" v-model="additionalEditorBehaviorCheckboxes.displayTotalQuantity">Display total quantity</base-checkbox></li>
                <li v-if='currentDocumentTypeCode=="ORIPOX"'><base-checkbox :data-testid="'enable-showing-supplier-stock-number-checkbox'" v-model="additionalEditorBehaviorCheckboxes.enableShowingSupplierStockNumber">Enable showing Supplier Stock Number in document</base-checkbox></li>
                <li v-if='["ORIPOX", "ORITRQ"].includes(currentDocumentTypeCode)'><base-checkbox :data-testid="'include-in-transit-for-min-max-auto-replenishment-checkbox'" v-model="additionalEditorBehaviorCheckboxes.includeInTransitForMinMaxAutoRep">Include in-transit quantity for auto-replenishment</base-checkbox></li>
                <li v-if='currentDocumentTypeCode=="RELDDE"'><base-checkbox :data-testid="'display-remarks-checkbox'" v-model="additionalEditorBehaviorCheckboxes.displayRemarks">Display Remarks</base-checkbox></li>
                <li v-if='currentDocumentTypeCode=="RELDDE"'><base-checkbox :data-testid="'display-ship-on-time-sla-checkbox'" v-model="additionalEditorBehaviorCheckboxes.displayShipOnTimeSLA">Display Ship-on-Time SLA</base-checkbox></li>
                <li v-if='currentDocumentTypeCode=="ORISOX"'><base-checkbox :data-testid="'auto-create-and-post-delivery-document-checkbox'" @change="checkAutocreationOfDD(additionalEditorBehaviorCheckboxes.autoCreatePostDD,'DD')" v-model="additionalEditorBehaviorCheckboxes.autoCreatePostDD">Auto create and post a Delivery Document upon posting</base-checkbox></li>
                <li v-if='currentDocumentTypeCode=="ORISOX"'><base-checkbox :data-testid="'auto-create-post-delivery-document-and-sales-invoice-checkbox'" @change="checkAutocreationOfDD(additionalEditorBehaviorCheckboxes.autoCreatePostDDAndSI,'DD&SI')" v-model="additionalEditorBehaviorCheckboxes.autoCreatePostDDAndSI">Auto create/post a Delivery Document and Sales Invoice upon posting</base-checkbox></li>
                
                <li v-if='currentDocumentTypeCode=="OTHPCN"'><base-checkbox :data-testid="'require-freeze-before-qty-edit-checkbox'"  v-model="additionalEditorBehaviorCheckboxes.require_freeze_before_qty_edit">Require Freeze Before Quantity Edit</base-checkbox></li>

                <li v-if='currentDocumentTypeCode=="ORISOX" || currentDocumentTypeCode=="RELDDE" || currentDocumentTypeCode=="OTHSIN"'><base-checkbox :data-testid="'display-vat-amount-checkbox'" v-model="additionalEditorBehaviorCheckboxes.displayVatAmount">Display Vat Amount</base-checkbox></li>
                <li v-if='currentDocumentTypeCode=="ORISOX" || currentDocumentTypeCode=="RELDDE" || currentDocumentTypeCode=="OTHSIN"'><base-checkbox :data-testid="'display-net-amount-without-vat-checkbox'" v-model="additionalEditorBehaviorCheckboxes.displayNetAmountWOVat">Display Net Amount Without VAT</base-checkbox>
                  <br>
                  <a-input :data-testid="'display-net-amount-without-vat-label-input'" placeholder="values" v-if="additionalEditorBehaviorCheckboxes.displayNetAmountWOVat" v-model="additionalEditorBehaviorCheckboxes.displayNetAmountWOVatLabel" default-value="Net Amount w/o VAT"/>
                </li>
                <li v-if='currentDocumentTypeCode=="OTHTRA" || currentDocumentTypeCode=="OTHPCK"'>
                  <br>
                  <base-input label="Import With Allocation Via">
                      <select :data-testid="'allocation-default-value-select'" class="form-control form-control-sm" input-classes="form-control" v-model="additionalEditorBehaviorCheckboxes.AllocationDefaultValue">
                          <option v-for="option in allocationOption" v-bind:value="option.value" :key="option.value">
                              {{ option.name }}
                          </option>
                      </select>
                  </base-input>
                </li>
              </ul>
            </a-tab-pane>
 
            <a-tab-pane v-if="showIncomingOrder && incomingOrder!=undefined" tab="Incoming Order" key="5">
              <p style="line-height: 90%;"><small>The settings applies to incoming order document</small></p>
              <div class="row">
                <div class="col-7 pt-1">
                  Number of days before cancellation:
                </div>
                <div class="col-5">
                  <a-input type="number" :data-testid="'cancellation-days-input'" style="width: 100%" :min="1" :max="100" v-model='incomingOrder.cancellationDays'/>
                </div>
              </div>
              <div class="row m-0 pt-2">
                <ul style="list-style-type:none" class='mb-0 pl-0'>
                  <li v-if="currentDocumentTypeCode=='ORITRQ'"><base-checkbox :data-testid="'create-stock-request-checkbox'" v-model='incomingOrder.createStockRequest'>Create stock request for serving document when stock request on order is posted</base-checkbox></li>
                  <li v-if="currentDocumentTypeCode=='ORITRQ'"><base-checkbox :data-testid="'post-stock-request-checkbox'" v-model='incomingOrder.postStockRequest'>Post stock request for serving document when stock request on order is posted</base-checkbox></li>
                  <li v-if="currentDocumentTypeCode=='ORICSQ'"><base-checkbox :data-testid="'create-concession-stock-request-checkbox'" v-model='incomingOrder.createConcessionStockRequest'>Create concession stock request for serving document when stock request on order is posted</base-checkbox></li>
                  <li v-if="currentDocumentTypeCode=='ORICSQ'"><base-checkbox :data-testid="'post-concession-stock-request-checkbox'" v-model='incomingOrder.postConcessionStockRequest'>Post concession stock request for serving document when stock request on order is posted</base-checkbox></li>
                  <li v-if="currentDocumentTypeCode=='RELSLO'"><base-checkbox :data-testid="'create-sublocation-transfer-in-checkbox'" v-model='incomingOrder.createRECSLI'>Create sublocation transfer in document when sublocation transfer out is posted</base-checkbox></li>
                  <li v-if="currentDocumentTypeCode=='RELSLO'"><base-checkbox :data-testid="'post-recsli-checkbox'" v-model='incomingOrder.postRECSLI'>Post sublocation transfer in document when sublocation transfer out is posted</base-checkbox></li>
                  <li v-if="currentDocumentTypeCode=='ORIPOX'"><base-checkbox :data-testid="'remember-last-discount-checkbox'" v-model='incomingOrder.rememberLastDiscount'>Remember last discount</base-checkbox></li>
                  <li v-if="currentDocumentTypeCode=='ORIPOX'"><base-checkbox :data-testid="'use-last-discount-checkbox'" v-model='incomingOrder.useLastDiscount'>Use last discount</base-checkbox></li>
                  <li v-if="currentDocumentTypeCode=='ORIPOX'" hidden><base-checkbox :data-testid="'require-supplier-in-po-checkbox'" v-model='incomingOrder.requireSupplierInPo'>Require Supplier in PO</base-checkbox></li>
                  <li v-if="currentDocumentTypeCode=='ORIPOX'"><base-checkbox :data-testid="'set-zero-default-quantity-checkbox'" v-model='incomingOrder.setZeroDefaultQuantityAutoPopulateSupplier'>Set to zero the default quantity in auto populate by supplier</base-checkbox></li>
                  <li v-if="currentDocumentTypeCode=='ORIPOX'"><base-checkbox :data-testid="'delete-zero-quantity-in-saving-checkbox'" v-model='incomingOrder.deleteZeroQuantityInSaving'>Delete zero quantity in saving document</base-checkbox></li>
                  <li v-if="currentDocumentTypeCode=='ORIPOX'"><base-checkbox :data-testid="'update-ordering-cost-posting-checkbox'" v-model='incomingOrder.updateOrderingCostPosting'>Update ordering cost during posting</base-checkbox></li>
                  <li v-if="currentDocumentTypeCode=='ORIPOX'"><base-checkbox :data-testid="'disable-autocreation-alternate-supplier-posting-checkbox'" v-model='incomingOrder.disableAutocreationAlternateSupplierPosting'>Disable autocreation of alternate supplier during posting</base-checkbox></li>
                </ul>
              </div>
            </a-tab-pane>
 
            <a-tab-pane v-if="showOutgoingOrder && outgoingOrder!=undefined" tab="Outgoing Order" key="5">
              <p style="line-height: 90%;"><small>The settings applies to outgoing order document</small></p>
              <div class="row">
                <div class="col-7 pt-1">
                  Number of days before cancellation:
                </div>
                <div class="col-5">
                  <a-input type="number" :data-testid="'cancellation-days-input'" style="width: 100%" :min="1" :max="100" v-model='outgoingOrder.cancellationDays' />
                </div>
              </div>
              <div class="row m-0 pt-2">
                <ul style="list-style-type:none" class='mb-0 pl-0'>
                  <li><base-checkbox :data-testid="'warn-not-enough-quantity-checkbox'" v-model='outgoingOrder.warnNotEnoughQuantity'>Warn user if there is not enough on hand quantity</base-checkbox></li>
                  <li><base-checkbox :data-testid="'restrict-not-enough-quantity-checkbox'" v-model='outgoingOrder.restrictNotEnoughQuantity'>Restrict adding item if there is not enough on hand quantity</base-checkbox></li>
                </ul>
              </div>
            </a-tab-pane>
 
            <a-tab-pane v-if="showReceivingDocument && receivingDocument!=undefined" tab="Receiving Document" key="5">
              <p style="line-height: 90%;"><small>The settings only applies to Receiving Documents (any document that increases the inventory of the system). For Example: Receiving Report, Adjustment In</small></p>
                <ul style="list-style-type:none" class='mb-0 pl-0'>
                  <li><base-checkbox :data-testid="'remember-last-discount-checkbox'" v-model='receivingDocument.rememberLastDiscount'>Remember last discount</base-checkbox></li>
                  <li><base-checkbox :data-testid="'use-last-discount-checkbox'" v-model='receivingDocument.useLastDiscount'>Use last discount</base-checkbox></li>
                  <li><base-checkbox :data-testid="'update-landed-cost-posting-checkbox'" v-model='receivingDocument.updateLandedCostPosting'>Update landed cost during posting</base-checkbox></li>
                  <li><base-checkbox :data-testid="'update-ordering-cost-posting-checkbox'" v-model='receivingDocument.updateOrderingCostPosting'>Update ordering cost during posting</base-checkbox></li>
                  <li><base-checkbox :data-testid="'enable-invoice-quantity-checkbox'" v-model='receivingDocument.enableInvoiceQuantity'>Enable invoice quantity</base-checkbox></li>
                  <li><base-checkbox :data-testid="'allow-zero-quantity-checkbox'" v-if="!((currentDocumentTypeCode=='RECTRX') || (currentDocumentTypeCode=='RECADJ'))" v-model='receivingDocument.allowZeroQuantityFromAutoGeneratedDocument'>Enable to allow zero quantity from auto-generated document </base-checkbox></li>
                  <!-- <li><a-checkbox v-if="!(currentDocumentTypeCode=='RECADJ')" v-model='receivingDocument.deleteZeroQuantityPosting'>Delete zero quantity in posting document</a-checkbox></li> -->
                  <li><base-checkbox :data-testid="'disable-autocreation-alternate-supplier-posting-checkbox'" v-if="!((currentDocumentTypeCode=='RECTRX') || (currentDocumentTypeCode=='RECADJ'))" v-model='receivingDocument.disableAutocreationAlternateSupplierPosting'>Disable autocreation of alternate supplier during posting</base-checkbox></li>
                  <li><base-checkbox :data-testid="'only-supervisor-change-document-date-checkbox'" v-if="!((currentDocumentTypeCode=='RECTRX') || (currentDocumentTypeCode=='RECADJ'))" v-model='receivingDocument.onlySupervisorChangeDocumentDate'>Only supervisor can change document date</base-checkbox></li>
                  <li><base-checkbox :data-testid="'set-zero-default-quantity-po-checkbox'" v-if="(currentDocumentTypeCode=='RECDEL')" v-model='receivingDocument.setZeroDefaultQuantityPo'>Set to zero the default quantity when created from PO</base-checkbox></li>
                  <li><base-checkbox :data-testid="'set-zero-default-quantity-sto-checkbox'" v-if="(currentDocumentTypeCode=='RECTRX')" v-model='receivingDocument.setZeroDefaultQuantitySto'>Set to zero the default quantity when created from STO</base-checkbox></li>
                  <!--- <li><base-checkbox :data-testid="'skip-checking-cost-layer-cancelling-document-checkbox'" v-model='receivingDocument.skipCheckingCostLayerCancellingDocument'>Skip checking cost layer when cancelling document</base-checkbox></li> --->
                  <li><base-checkbox :data-testid="'strict-posting-with-zero-cost-checkbox'" v-if="['RECADJ', 'RECDEL', 'RECTRX'].includes(currentDocumentTypeCode)" v-model='receivingDocument.strictPostingWithZeroCost'>Restrict posting with ZERO cost</base-checkbox></li>
                </ul>
            </a-tab-pane>
 
            <a-tab-pane v-if="showReleasingDocument && releasingDocument!=undefined" tab="Releasing Document" key="5">
              <p style="line-height: 90%;"><small>The settings only applies to Releasing Documents (any document which decreases the inventory of the system)</small></p>
                <ul style="list-style-type:none" class='mb-0 pl-0'>
                  <li><base-checkbox :data-testid="'warn-not-enough-quantity-checkbox'" v-model='releasingDocument.warnNotEnoughQuantity'>Warn user if there is not enough on hand quantity</base-checkbox></li>
                  <li><base-checkbox :data-testid="'allow-posting-not-enough-quantity-checkbox'" v-model='releasingDocument.allowPostingNotEnoughtQuantity'>Allow posting to proceed even if there is not enough on hand quantity</base-checkbox></li>
                  <li><base-checkbox :data-testid="'update-price-from-cost-posting-checkbox'" v-model='releasingDocument.updatePriceFromCostPosting'>Update price from cost when posting</base-checkbox></li>
                  <li><base-checkbox v-model='releasingDocument.followParentCostDuringPosting' v-if="['RELRSR'].includes(currentDocumentTypeCode)">Follow RR Cost during posting</base-checkbox></li>
                  <li><base-checkbox :data-testid="'restrict-adding-item-not-enough-quantity-checkbox'" v-model='releasingDocument.restrictAddingItemNotEnoughQuantity'>Restrict adding item if there is not enough on hand quantity</base-checkbox></li>
                </ul>
            </a-tab-pane>
 
            <a-tab-pane v-if="showReceivingDocumentWithOrder && receivingDocumentWithOrder!=undefined" tab="Receiving Document with Order" key="6">
              <p style="line-height: 90%;"><small>The settings only applies to Receiving Documents which have prior Order Documents. For Example: The Receving Report</small></p>
                <ul style="list-style-type:none" class='mb-0 pl-0'>
                  <li><base-checkbox :data-testid="'mark-partially-delivered-done-checkbox'" v-model='receivingDocumentWithOrder.markPartiallyDeliveredDone'>Mark partially delivery as done</base-checkbox></li>
                  <li><base-checkbox :data-testid="'auto-create-purchase-order-exceeding-quantity-checkbox'" v-model='receivingDocumentWithOrder.autoCreatePurchaseOrderExceedingQuantity'>Auto create another Purchase Order when Receiving Report quantity exceeds Purchase Order Quantity</base-checkbox></li>
                  <!-- <li><a-checkbox v-model='receivingDocumentWithOrder.populateReceivingReportQuantityBasedOnPurchaseOrder'>Populate Receiving Report Quantity based on Purchase Order Quantity</a-checkbox></li> -->
                </ul>
            </a-tab-pane>
 
            <a-tab-pane v-if="showReleasingDocumentWithOrder && releasingDocumentWithOrder!=undefined" tab="Releasing Document with Order" key="7">
              <p style="line-height: 90%;"><small>The settings only applies to Releasing Documents which have prior Order Documents. For Example: The Stock Transfer with prior Stock Request</small></p>
                <ul style="list-style-type:none" class='mb-0 pl-0'>
                  <li><base-checkbox :data-testid="'mark-partially-delivered-done-checkbox'" v-model='releasingDocumentWithOrder.markPartiallyDeliveredDone'>Mark partially delivery as done</base-checkbox></li>
                </ul>
            </a-tab-pane>
 
 
            <a-tab-pane v-if="showTransferDocument && transferDocument!=undefined" tab="Transfer Document" key="8">
              <p style="line-height: 90%;"><small>The settings only applies to Transfer Documents</small></p>
                <ul style="list-style-type:none" class='mb-0 pl-0'>
                  <!-- <li><base-checkbox :data-testid="'create-transfer-in-when-transfer-out-posted-checkbox'" v-model='transferDocument.createTransferInWhenTransferOutPosted'>Create transfer in document when transfer out is posted</base-checkbox></li> -->
                  <li><base-checkbox :data-testid="'post-transfer-in-when-transfer-out-posted-checkbox'" v-model='transferDocument.postTransferInWhenTransferOutPosted'>Post transfer in document when transfer out is posted</base-checkbox></li>
                </ul>
            </a-tab-pane>
 
            <a-tab-pane v-if="showOrderSourceMode && orderSource!=undefined" tab="Order Source Mode" key="9">
              <p style="line-height: 90%;"><small>The settings only applies to Sales Order Document <br> <br> Enabling this setting will change selection of sublocation to order source for Sales Order, Delivery Document and Sales Invoice</small></p>
              <base-checkbox :data-testid="'enable-order-source-mode-checkbox'" v-model='orderSource.enableOrderSourceMode'>Enable Order Source Mode</base-checkbox>
              <a-select :data-testid="'order-sources-select'" v-if='orderSource.enableOrderSourceMode' mode="tags" class="col-12 mt-2" v-model='orderSource.orderSources' style="width: 100%;" placeholder='Please define order sources' input-classes="form-control"></a-select>
            </a-tab-pane>
 
            <a-tab-pane v-if="showPrintSettings" tab="Print Settings" key="10">
              <ul style="list-style-type:none" class='p-0'>
                <li v-if="currentDocumentTypeCode=='ORIPOX'"><base-checkbox :data-testid="'enable-showing-initial-deposit-field-checkbox'" v-model="printSettings.enableShowingInitialDepositField">Enable showing initial Deposit field</base-checkbox></li>
                <li v-if="currentDocumentTypeCode=='ORIPOX'"><base-checkbox :data-testid="'enable-showing-balance-field-checkbox'" v-model="printSettings.enableShowingBalanceField">Enable showing Balance field</base-checkbox></li>
                <li v-if="currentDocumentTypeCode=='ORIPOX'"><base-checkbox :data-testid="'enable-showing-price-inclusion-field-checkbox'" v-model="printSettings.enableShowingPriceInclusionField">Enable showing Price Inclusion field</base-checkbox></li>
                <li v-if="currentDocumentTypeCode=='ORIPOX'"><base-checkbox :data-testid="'enable-showing-comment-1-field-checkbox'" v-model="printSettings.enableShowingComment1Field">Enable showing Comment 1 field</base-checkbox></li>
                <li v-if="currentDocumentTypeCode=='ORIPOX'"><base-checkbox :data-testid="'enable-showing-comment-2-field-checkbox'" v-model="printSettings.enableShowingComment2Field">Enable showing Comment 2 field</base-checkbox></li>
                <li v-if="currentDocumentTypeCode=='ORIPOX'"><base-checkbox :data-testid="'include-image-in-printout-checkbox'" v-model="printSettings.includeImageInPrintout">Include Product Image in printout document</base-checkbox></li>
                <li v-if="currentDocumentTypeCode=='ORIPOX'"><base-checkbox :data-testid="'show-stock-no-in-product-list-checkbox'" v-model="printSettings.showStockNoInProductList">Show Supplier Stock No. column in the product list</base-checkbox></li>
                <li v-if="currentDocumentTypeCode=='ORIPOX'"><base-checkbox :data-testid="'show-design-and-size-in-product-list-checkbox'" v-model="printSettings.showDesignAndSizeInProductList">Show Design and Size column in the product list</base-checkbox></li>
                <li v-if="currentDocumentTypeCode=='ORIPOX'"><base-checkbox :data-testid="'show-serial-no-in-product-list-checkbox'" v-model="printSettings.showSerialNoInProductList">Show serial No. column in the product list</base-checkbox></li>
                <li><base-checkbox :data-testid="'show-discount-amount-checkbox'" v-model="printSettings.showDiscountAmount">Show Discount Amount</base-checkbox></li>
                <li><base-checkbox :data-testid="'show-total-vat-checkbox'" v-model="printSettings.showTotalVat">Show VAT amount</base-checkbox></li>
                <li><base-checkbox :data-testid="'show-net-amount-without-vat-checkbox'" v-model="printSettings.showNetAmountWithoutVat">Show Net Amount W/o VAT </base-checkbox></li>
                <li><base-checkbox :data-testid="'show-total-price-checkbox'" v-model="printSettings.showTotalPrice">Show Total Price</base-checkbox></li>
                
                <!-- <li v-if="currentDocumentTypeCode!='ORISOX' && currentDocumentTypeCode!='RELDDE' && currentDocumentTypeCode!='OTHSIN'"><a-checkbox v-model="printSettings.showRefCode">Enable showing ERP Code field</a-checkbox></li> -->
                <li><base-checkbox :data-testid="'enable-landscape-printing-checkbox'" v-model="printSettings.enableLandscapePrinting">Enable landscape PDF Printing</base-checkbox></li>
                <li v-if="currentDocumentTypeCode!='ORISOX' && currentDocumentTypeCode!='RELDDE' && currentDocumentTypeCode!='OTHSIN'"><base-checkbox :data-testid="'show-erp-code-checkbox'" v-model="printSettings.showErpCode">Enable showing ERP Code field</base-checkbox></li>
                <li v-if="currentDocumentTypeCode=='ORISOX' || currentDocumentTypeCode=='RELDDE' || currentDocumentTypeCode=='OTHSIN' || currentDocumentTypeCode=='ORORSO'"><base-checkbox :data-testid="'show-other-charges-checkbox'" v-model="printSettings.showOtherCharges">show Other Charges</base-checkbox></li>
              </ul>
            </a-tab-pane>
 
            <a-tab-pane v-if="showCustomerReturn && customerReturn!=undefined" tab="Customer Return" key="11">
              <p style="line-height: 90%;"><small>The settings only applies to Customer Return Documents</small></p>
                <ul style="list-style-type:none" class='mb-0 pl-0'>
                  <li>
                    <base-checkbox :data-testid="'limit-return-period-checkbox'" v-model="customerReturn.limitReturnPeriod">Set a time limit (in days) for returning items.</base-checkbox>
                    <ul>
                      <li>
                        <a-input type="number" :data-testid="'limit-return-period-input'" :disabled="!customerReturn.limitReturnPeriod" style="width: 50%" :min="1" v-model='customerReturn.returnGracePeriod'> Allowable Grace Period (in days) for returns.</a-input>
                      </li>
                    </ul>
                  </li>
                </ul>
            </a-tab-pane>
 
            <a-tab-pane tab="Action History" key="12">
              <div>
                <h6 class="heading-small text-muted mb-4 text-truncate">Document Configuration Action History</h6>
                <a-table :columns="historyColumns" :dataSource="historyData" size="small"/>
                </div>
            </a-tab-pane>
 
            <a-tab-pane tab="Product Custom Fields" key="13">
              <small> Select three custom fields to be displayed in the document form </small>
              <!-- <a-select mode="multiple" style="width: 100%" placeholder="Please select" optionFilterProp="children"  v-model="settingsModel[setting['code']]"></a-select> -->
              <a-select :data-testid="'product-custom-fields-select'" mode="multiple" style="width: 100%" placeholder="Please select" optionFilterProp="children" v-model="productCustomFieldsSelected" @select="productCustomFieldsCheck">
                <!-- v-model="settingsModel[setting['code']]" :disabled="checkDisabled(setting) == true" -->
                <a-select-option v-for="option in productCustomFields" :key="option.code" :value="option.code">{{option.name}}</a-select-option>
              </a-select>
            </a-tab-pane>
 
          </a-tabs>
          <br/>
          <br/>
          <div style="position: absolute; bottom: 0px;right: 0px; width: -webkit-fill-available; background-color: #f2f2f2 ;padding: 10px;">
            <a-spin :tip="spinMessage" :spinning="spinning">
              <button data-testid="doc-conf-save-button" type="button" class="btn btn-primary float-right" @click.prevent="save">Save</button>
            </a-spin>
          </div>
      </form>
   </div>
  
 </template>
 
 <script>
  import HTTPRequest from '../../controllers/httpRequest.js'
  import { mapState } from 'vuex'
  import secureStorage from '../../controllers/secureStorage'
  import moment from 'moment';
 
  var component_x;
  export default {
    data() {
      return {
        spinMessage: 'Saving......',
        spinning : false,
        currentDocumentTypeId: null,
        currentDocumentTypeCode: '',
        documentName: '',
        documentCode: '',
        documenttransCode: '',
        documentFriendlyCode: '',
        productCustomFields: [],
        productCustomFieldsSelected: [],
 
        priceOrCost: "Landed Cost", //Default Selected Price or Cost
        priceCostOptions: [
          "Landed Cost", "Retail Price", "Ordering Cost", "Original Cost","Wholesale Price",
        ],
 
        references: [
          {name: 'reference', value: '', duplicate: false},
          {name: 'reference 2', value: '', duplicate: false},
          {name: 'reference 3', value: '', duplicate: false},
          {name: 'reference 4', value: '', duplicate: false},
          {name: 'reference 5', value: '', duplicate: false},
          {name: 'reference 6', value: '', duplicate: false},
          {name: 'reference 7', value: '', duplicate: false},
          {name: 'reference 8', value: '', duplicate: false},
          {name: 'reference 9', value: '', duplicate: false},
          {name: 'reference 10', value: '', duplicate: false},
        ],
 
        prefixSearchOption:[
          {name: 'Brand Name', value: 'brand_name'},
          {name: 'Stock no', value: 'stock_no'},
          {name: 'Reference Code', value: 'reference_code'},
        ],
 
        editorBehavior: {
          lineRestrictionCheckboxIsDisabled: true,
          maxMassUploadLineRestrictionInput:null,
          prefixSearch: null,
          revenueCreditingMode:"M"
        },
        editorBehaviorRadioOptions: [
          { label: 'Standard - Do not allow duplicate product', value: 'S' },
          { label: 'Linear - Allow duplicate entries', value: 'L' },
          { label: 'POS - Quantity entered is added to previous quantity', value: 'P' },
        ],
        revenueCreditingModeOption:[
          {name: 'Requesting', value: 'R'},
          {name: 'Target', value: 'T'},
          {name: 'Manual', value: 'M'},
        ],
        allocationOption:[
          {name: 'Site Code', value: 'SC'},
          {name: 'Reference Code', value: 'RC'},
        ],
        additionalEditorBehavior: {
          offtakeDays: 60,
          enableStockRequestCutOff: false,
          stockRequestCutOffTime: null,
          stockRequestCutOffBehavior: 'warn',
        },
        additionalEditorBehaviorCheckboxes: {
          restrictWithoutOriginDoc: false,
          confirmDocumentStatus: false,
          itemDescEditForPrinting: false,
          auditTrail: false,
          enableAddCharges: false,
          termsAndDiscount: true,
          fourDecimalPlaces: false,
          filterProductBySupplier: false,
          updateLastArrivalDateWhenPosted: true,
          updateLastArrivalQuantityWhenPosted: true,
          updateLastArrivalSupplierWhenPosted: true,
          packageDefaultItemEncoding: false,
          showVatExclusiveAmount: true,
          showPoBalanceQuantityWithColorCoding: false,
          restrictBackDatingInDocuments: false,
          allowPromotionComputation: false,
          automaticPostingOnSave: false,
          allowPaymentOnPosting: false,
          autoCreateSalesInvoiceOnPosting: false,
          autoCreateAndPostSalesInvoiceOnPosting: false,
          allowCreationOfDDWithoutSO:false,
          autoCreatePostDDAndSI:false,
          displayAllReferences:false,
          displayTotalQuantity:false,
          enableShowingSupplierStockNumber:false,
          enableRecordingOfInitialDeposit:false,
          displayRemarks:false,
          displayShipOnTimeSLA:false,
          autoCreatePostDD: false,
          displayVatAmount: false,
          displayNetAmountWOVat: false,
          displayNetAmountWOVatLabel:"Net Amount w/o VAT",
          AllocationDefaultValue:'SC'
        },
 
        incomingOrder: {
          cancellationDays: 30,
          createStockRequest: false,
          postStockRequest: false,
          createRECSLI: false,
          postRECSLI: false,
          rememberLastDiscount: true,
          useLastDiscount: true,
          requireSupplierInPo: true,
          setZeroDefaultQuantityAutoPopulateSupplier: false,
          deleteZeroQuantityInSaving: true,
          updateOrderingCostPosting: true,
          disableAutocreationAlternateSupplierPosting: false,
        },
        outgoingOrder: {
          cancellationDays: 30,
          warnNotEnoughQuantity: false,
          restrictNotEnoughQuantity: false
        },
        receivingDocument: {
          rememberLastDiscount: false,
          useLastDiscount: true,
          updateLandedCostPosting: true,
          updateOrderingCostPosting: true,
          enableInvoiceQuantity: false,
          allowZeroQuantityFromAutoGeneratedDocument: false,
          deleteZeroQuantityPosting: false,
          disableAutocreationAlternateSupplierPosting: false,
          onlySupervisorChangeDocumentDate: true,
          setZeroDefaultQuantityPo: false,
          //skipCheckingCostLayerCancellingDocument: false,
        },
        receivingDocumentWithOrder: {
          markPartiallyDeliveredDone: false
        },
        releasingDocument: {
          warnNotEnoughQuantity: true,
          allowPostingNotEnoughtQuantity: true,
          updatePriceFromCostPosting: false,
          restrictAddingItemNotEnoughQuantity: false,
          followParentCostDuringPosting: false
        },
        releasingDocumentWithOrder: {
          markPartiallyDeliveredDone: false
        },
 
        transferDocument: {
          createTransferInWhenTransferOutPosted: true,
          postTransferInWhenTransferOutPosted: false
        },
 
        orderSource: {
          enableOrderSourceMode: false,
          orderSources: [],
        },
        printSettings:{
          enableShowingInitialDepositField:false,
          enableShowingPriceInclusionField:false,
          enableShowingBalanceField:false,
          enableShowingComment1Field:false,
          enableShowingComment2Field:false,
          includeImageInPrintout:false,
          showStockNoInProductList:false,
          showSerialNoInProductList:false,
          showDesignAndSizeInProductList:false,
          enableLandscapePrinting:false,
          showTotalVat:false,
          showDiscountAmount:false,
          showNetAmountWithoutVat:false,
          showTotalPrice:false,
          showOtherCharges:false,
        },
        customerReturn: {
          limitReturnPeriod: false,
          returnGracePeriod: 1
        },
        showIncomingOrder: false,
        showOutgoingOrder: false,
        showReceivingDocument: false,
        showReleasingDocument: false,
        showReceivingDocumentWithOrder: false,
        showReleasingDocumentWithOrder: false,
        showTransferDocument: false,
        showOrderSourceMode: false,
        showPrintSettings:false,
        showCustomerReturn:false,
        historyData: [],
        historyVisible: false,
        historyColumns: [
          {
          title: 'Action',
          dataIndex: 'action',
          },
          {
          title: 'Action By',
          dataIndex: 'action_by',
          },
          {
          title: 'Action At',
          dataIndex: 'action_at',
          customRender: (value) => <div>{moment(value).format('YYYY-MM-DD HH:mm:ss A')}</div>
          },
        ],
        initialSettings: {},
        logSettings: {},
        diffSettings: [],
      }
    },
    computed: {
        ...mapState(['currentProfile', 'currentApiURL', 'endPoint', 'profileId', 'parameters', 'serverType']),
        filteredPriceCostOptions(){
          return this.priceCostOptions.filter(o => o!= this.priceOrCost);
        },
        // The cut-off time is stored as an "hh:mm A" string. Expose it as a moment
        // object for the a-time-picker component.
        cutOffTimeMoment(){
          var t = this.additionalEditorBehavior.stockRequestCutOffTime;
          return t ? moment(t, 'hh:mm A') : null;
        }
    },
    mounted: async function() {
        component_x = this
        this.currentDocumentTypeId = secureStorage.getItem("documentTypeId")
        this.currentDocumentTypeCode = secureStorage.getItem("documentTypeCode") || ''
        this.historyData = await HTTPRequest.getRequest(component_x.endPoint + "document_configuration_action_histories/"+this.currentDocumentTypeId+"?field_name=document_id", null);
        var data = await HTTPRequest.getRequest(component_x.endPoint+'/document_types?id='+ component_x.currentDocumentTypeId, null)
        if (data[0] != undefined) {
          component_x.documentName = data[0].name
          component_x.documentCode = data[0].type_code
          component_x.documenttransCode = data[0].trans_code
          component_x.documentFriendlyCode = data[0].friendly_code
        }
        var config = await HTTPRequest.getRequest(component_x.endPoint+'/document_types/get_document_type_settings?id='+ component_x.currentDocumentTypeId, null)
        if (config.document_type_settings != undefined) {
 
          component_x.productCustomFieldsSelected = config.document_type_settings.customFields
 
          component_x.priceOrCost = config.document_type_settings.priceOrCost
          // this.initialSettings.push( {"upriceOrCost": config.document_type_settings.priceOrCost} )
          this.initialSettings = Object.assign(this.initialSettings, {"upriceOrCost": config.document_type_settings.priceOrCost})
          // component_x.references = config.document_type_settings.references
          component_x.editorBehavior = config.document_type_settings.editorBehavior
          component_x.editorBehavior.maxMassUploadLineRestrictionInput = (config.document_type_settings.editorBehavior.maxMassUploadLineRestrictionInput) ? config.document_type_settings.editorBehavior.maxMassUploadLineRestrictionInput : 200
 
          // component_x.additionalEditorBehavior = config.document_type_settings.additionalEditorBehavior
          // component_x.additionalEditorBehavior.offtakeDays = (component_x.additionalEditorBehavior.offtakeDays) ? component_x.additionalEditorBehavior.offtakeDays : 60
 
          // this.initialSettings.push( {"ueditorBehavior": this.pushInitSettings(config.document_type_settings.editorBehavior)} )
          this.initialSettings = Object.assign(this.initialSettings, {"ueditorBehavior": this.pushInitSettings(config.document_type_settings.editorBehavior)})
          component_x.additionalEditorBehaviorCheckboxes = config.document_type_settings.additionalEditorBehaviorCheckboxes
          // this.initialSettings.push( {"uadditionalEditorBehaviorCheckboxes": this.pushInitSettings(config.document_type_settings.additionalEditorBehaviorCheckboxes)} )
          this.initialSettings = Object.assign(this.initialSettings, {"uadditionalEditorBehaviorCheckboxes": this.pushInitSettings(config.document_type_settings.additionalEditorBehaviorCheckboxes)})
          if(config.document_type_settings.printSettings != undefined){
            // this.initialSettings.push( {"uprintSettings": this.pushInitSettings(config.document_type_settings.printSettings)} )
            this.initialSettings = Object.assign(this.initialSettings, {"uprintSettings": this.pushInitSettings(config.document_type_settings.printSettings)})
            component_x.printSettings = config.document_type_settings.printSettings
          } 
 
          // For NEW document form setting, kindly push to initialSettings; (u + settingsDesc)
          // this.initialSettings = Object.assign(this.initialSettings, {"usampleSettings": this.pushInitSettings(config.document_type_settings.usampleSettings)})
 
          if (config.document_type_settings.incomingOrder != undefined){
            // this.initialSettings.push( {"uincomingOrder": this.pushInitSettings(config.document_type_settings.incomingOrder)} )
            this.initialSettings = Object.assign(this.initialSettings, {"uincomingOrder": this.pushInitSettings(config.document_type_settings.incomingOrder)})
            component_x.incomingOrder = config.document_type_settings.incomingOrder
          } 
 
          if (config.document_type_settings.additionalEditorBehavior != undefined){
            this.initialSettings = Object.assign(this.initialSettings, {"uadditionalEditorBehavior": this.pushInitSettings(config.document_type_settings.additionalEditorBehavior)})
            component_x.additionalEditorBehavior = config.document_type_settings.additionalEditorBehavior
            // Merge defaults for newer keys (e.g. stock request cut-off) so configs
            // saved before this feature still render with sensible defaults. Use
            // $set so the added keys are reactive (Vue 2 cannot detect plain
            // property additions), otherwise the toggle/v-if won't update.
            if (component_x.additionalEditorBehavior.enableStockRequestCutOff === undefined) component_x.$set(component_x.additionalEditorBehavior, 'enableStockRequestCutOff', false)
            if (component_x.additionalEditorBehavior.stockRequestCutOffTime === undefined) component_x.$set(component_x.additionalEditorBehavior, 'stockRequestCutOffTime', null)
            if (component_x.additionalEditorBehavior.stockRequestCutOffBehavior === undefined) component_x.$set(component_x.additionalEditorBehavior, 'stockRequestCutOffBehavior', 'warn')
          } 
 
          if (config.document_type_settings.outgoingOrder != undefined){
            // this.initialSettings.push( {"uoutgoingOrder": this.pushInitSettings(config.document_type_settings.outgoingOrder)} )
            this.initialSettings = Object.assign(this.initialSettings, {"uoutgoingOrder": this.pushInitSettings(config.document_type_settings.outgoingOrder)})
            component_x.outgoingOrder = config.document_type_settings.outgoingOrder
          } 
          if (config.document_type_settings.receivingDocument != undefined){
            // this.initialSettings.push( {"ureceivingDocument": this.pushInitSettings(config.document_type_settings.receivingDocument)} )
            this.initialSettings = Object.assign(this.initialSettings, {"ureceivingDocument": this.pushInitSettings(config.document_type_settings.receivingDocument)})
            component_x.receivingDocument = config.document_type_settings.receivingDocument
          }
          if (config.document_type_settings.receivingDocumentWithOrder != undefined){
            // this.initialSettings.push( {"ureceivingDocumentWithOrder": this.pushInitSettings(config.document_type_settings.receivingDocumentWithOrder)} )
            this.initialSettings = Object.assign(this.initialSettings, {"ureceivingDocumentWithOrder": this.pushInitSettings(config.document_type_settings.receivingDocumentWithOrder)})
            component_x.receivingDocumentWithOrder = config.document_type_settings.receivingDocumentWithOrder
          } 
          if (config.document_type_settings.releasingDocument != undefined){
            // this.initialSettings.push( {"ureleasingDocument": this.pushInitSettings(config.document_type_settings.releasingDocument)} )
            this.initialSettings = Object.assign(this.initialSettings, {"ureleasingDocument": this.pushInitSettings(config.document_type_settings.releasingDocument)})
            component_x.releasingDocument = config.document_type_settings.releasingDocument
          } 
          if (config.document_type_settings.releasingDocumentWithOrder != undefined){
            // this.initialSettings.push( {"ureleasingDocumentWithOrder": this.pushInitSettings(config.document_type_settings.releasingDocumentWithOrder)} )
            this.initialSettings = Object.assign(this.initialSettings, {"ureleasingDocumentWithOrder": this.pushInitSettings(config.document_type_settings.releasingDocumentWithOrder)})
            component_x.releasingDocumentWithOrder = config.document_type_settings.releasingDocumentWithOrder
          } 
          if (config.document_type_settings.transferDocument != undefined){
            // this.initialSettings.push( {"utransferDocument": this.pushInitSettings(config.document_type_settings.transferDocument)} )
            this.initialSettings = Object.assign(this.initialSettings, {"utransferDocument": this.pushInitSettings(config.document_type_settings.transferDocument)})
            component_x.transferDocument = config.document_type_settings.transferDocument
          } 
          if (config.document_type_settings.orderSource != undefined){
            // this.initialSettings.push( {"uorderSource": this.pushInitSettings(config.document_type_settings.orderSource)} )
            this.initialSettings = Object.assign(this.initialSettings, {"uorderSource": this.pushInitSettings(config.document_type_settings.orderSource)})
            component_x.orderSource = config.document_type_settings.orderSource
          } 
          if (config.document_type_settings.customerReturn != undefined){
            // this.initialSettings.push( {"ucustomerReturn": this.pushInitSettings(config.document_type_settings.customerReturn)} )
            this.initialSettings = Object.assign(this.initialSettings, {"ucustomerReturn": this.pushInitSettings(config.document_type_settings.customerReturn)})
            component_x.customerReturn = config.document_type_settings.customerReturn
          }
        }
        component_x.showIncomingOrder =  (component_x.currentDocumentTypeCode=='ORITRQ' || component_x.currentDocumentTypeCode=='ORICSQ' || component_x.currentDocumentTypeCode=='ORIPOX' || component_x.currentDocumentTypeCode=='RELSLO')
        component_x.showOutgoingOrder = (component_x.currentDocumentTypeCode=='OROTRQ' || component_x.currentDocumentTypeCode=='OROCSQ')
        component_x.showReceivingDocument = (component_x.currentDocumentTypeCode=='RECDEL' || component_x.currentDocumentTypeCode=='RECTRX' || component_x.currentDocumentTypeCode=='RECCSX' || component_x.currentDocumentTypeCode=='RECADJ')
        component_x.showReleasingDocument = (component_x.currentDocumentTypeCode=='RELRSR' || component_x.currentDocumentTypeCode=='RELTRX' || component_x.currentDocumentTypeCode=='RELCSX' || component_x.currentDocumentTypeCode=='RELADJ')
        component_x.showReceivingDocumentWithOrder = (component_x.currentDocumentTypeCode=='RECDEL')
        component_x.showReleasingDocumentWithOrder = (component_x.currentDocumentTypeCode=='RELTRX' || component_x.currentDocumentTypeCode=='RELCSX')
        component_x.showTransferDocument = (component_x.currentDocumentTypeCode=='RELTRX')
        component_x.showOrderSourceMode = (component_x.currentDocumentTypeCode=='ORISOX')
        component_x.showPrintSettings = true
        component_x.showCustomerReturn = (component_x.currentDocumentTypeCode=='RECCSR')
 
        var user_settings = await HTTPRequest.getRequest(this.endPoint + '/user_settings?user_specific=Y&module_name=ORISOX');
        if (user_settings.data.length > 0){
          var data = user_settings.data
          var index = data.findIndex(p => p.module_name == "ORISOX")
          if (index > -1){
            this.orderSource.enableOrderSourceMode = user_settings.data[index].settings_json.isSourceMode
          }else{
            this.orderSource.enableOrderSourceMode = user_settings.data[0].settings_json.isSourceMode
          }
        }
        if (this.documentCode == 'POX' && this.documenttransCode == 'ORI'){
          const index = component_x.priceCostOptions.indexOf("Retail Price");
          if (index > -1) {
            component_x.priceCostOptions.splice(index, 1);
          }
        }
        if ((this.documentCode == 'POX' && this.documenttransCode == 'ORI') || (this.documentCode == 'DEL' && this.documenttransCode == 'REC') || (this.documentCode == 'PUR' && this.documenttransCode == 'OTH')){
          var get_currency_count = await HTTPRequest.getRequest(this.endPoint + 'currencies/total_currency');
          if (get_currency_count["error"] == undefined){
            if (get_currency_count["total"]>0){
              const index = component_x.priceCostOptions.indexOf("Landed Cost");
              if (index > -1) {
                this.priceCostOptions.splice(index, 1);
                if (component_x.priceOrCost == "Landed Cost"){
                  component_x.priceOrCost = "Ordering Cost"
                }
              }
            }
          }
        }
        //  add wholesale price option
        var removeWholesalePrice = true;
        if ((this.documentCode == 'SIN' && this.documenttransCode == 'OTH') || (this.documentCode == 'SOX' && this.documenttransCode == 'ORI')) {
          removeWholesalePrice = false;
        }
        if (removeWholesalePrice) {
          const index = component_x.priceCostOptions.indexOf("Wholesale Price");
          if (index > -1) {
            this.priceCostOptions.splice(index, 1);
          }
        }
 
        // Product Custom Fields
        // productCustomFields
        // https://hq.bxi.world:8086/api/v2/account_system_modules/123?field_name=system_module_id&account_id=45
        console.log(">>> Should populate product custom fields")
        var test = 123
        var accountId = secureStorage.getItem("accountId")
        var getMeta = await HTTPRequest.getRequest(component_x.endPoint + "account_system_modules/"+ test + "?field_name=system_module_id&account_id=" + accountId, null);
        // console.log(getMeta.meta)
        component_x.productCustomFields = JSON.parse(getMeta.meta).customized_fields
        console.log(component_x.productCustomFields)
    },
 
    methods: {
       moment,
      async create_action_history(action) {
        var actionHistoryPayload = {
            action: action,
            action_at: moment(new Date()),
            action_by: secureStorage.getItem("userName"),
            document_id: this.currentDocumentTypeId,
            status: "A"
        }
        await HTTPRequest.postRequest(this.endPoint + 'document_configuration_action_histories/', null, actionHistoryPayload)
      },
        
      toggleLineRestrictionCheckbox(e) {
        this.editorBehavior.lineRestrictionCheckboxIsDisabled = !e.target.checked
        this.editorBehavior.lineRestrictionCheckbox = e.target.checked
        if (!e.target.checked) {
          this.editorBehavior.lineRestrictionInput = null;
        }
      },
      changePriceOrCost(selectedItem){
        this.priceOrCost = selectedItem;
      },
      onCutOffTimeChange(time){
        // Persist the cut-off as a stable "hh:mm A" string (a-time-picker emits a moment).
        this.additionalEditorBehavior.stockRequestCutOffTime = time ? time.format('hh:mm A') : null;
      },
      productCustomFieldsCheck(selectedItem){
        console.log(">>>> here")
        var checker = this.productCustomFieldsSelected.length
        // console.log("Length -- " + checker)
        if(checker  > 3){
          console.log("Here")
          this.productCustomFieldsSelected.pop();
          this.$notification['error'](
                {
                    message: "Action Error",
                    description: "Maximum allowed (3) custom fields reached."
                }
          );
        }
      },
      getComparison(from, to) {
        /**
         * Deeply compare two objects and return the differences.
         * @param  {Object} obj1 - The baseline object ("from").
         * @param  {Object} obj2 - The comparison object ("to").
         * @return {Object} - An object containing only the differences.
         */
        const diff = (obj1, obj2) => {
          // If obj2 is missing or not an object, everything in obj1 is considered different
          if (!obj2 || Object.prototype.toString.call(obj2) !== '[object Object]') {
            return obj1;
          }

          const diffs = {};

          /**
           * Check if two arrays are identical
           */
          const arraysMatch = (arr1, arr2) => {
            if (arr1.length !== arr2.length) return false;
            return arr1.every((val, idx) => val === arr2[idx]);
          };

          /**
           * Compare two values and record differences in `diffs`
           */
          const compare = (item1, item2, key) => {
            const type1 = Object.prototype.toString.call(item1);
            const type2 = Object.prototype.toString.call(item2);

            // Case 1: item removed
            if (type2 === '[object Undefined]') {
              diffs[key] = null;
              return;
            }

            // Case 2: type mismatch → overwrite with new value
            if (type1 !== type2) {
              diffs[key] = item2;
              return;
            }

            // Case 3: nested object → recurse
            if (type1 === '[object Object]') {
              const nestedDiff = diff(item1, item2);
              if (Object.keys(nestedDiff).length > 0) {
                diffs[key] = nestedDiff;
              }
              return;
            }

            // Case 4: arrays → compare element-by-element
            if (type1 === '[object Array]') {
              if (!arraysMatch(item1, item2)) {
                diffs[key] = item2;
              }
              return;
            }

            // Case 5: functions → compare stringified
            if (type1 === '[object Function]') {
              if (item1.toString() !== item2.toString()) {
                diffs[key] = item2;
              }
              return;
            }

            // Case 6: primitives → direct compare
            if (item1 !== item2) {
              diffs[key] = item2;
            }
          };

          // Compare keys in obj1
          for (const key in obj1) {
            if (Object.prototype.hasOwnProperty.call(obj1, key)) {
              compare(obj1[key], obj2[key.substring(1)], key);
            }
          }

          // Add keys only in obj2
          for (const key in obj2) {
            if (Object.prototype.hasOwnProperty.call(obj2, key)) {
              if (!(key in obj1)) {
                diffs[key] = obj2[key.substring(1)];
              }
            }
          }

          return diffs;
        };

        return diff(from, to);
      },

      async compareMe() {
        // Build logSettings more efficiently in one step instead of multiple Object.assign()
        this.logSettings = {
          document_type: {
            name: this.documentName,
            friendly_code: this.documentFriendlyCode
          },
          priceOrCost: this.priceOrCost,
          references: this.references,
          editorBehavior: this.editorBehavior,
          additionalEditorBehavior: this.additionalEditorBehavior,
          additionalEditorBehaviorCheckboxes: this.additionalEditorBehaviorCheckboxes,
          printSettings: this.printSettings,
          outgoingOrder: this.outgoingOrder,
          incomingOrder: this.incomingOrder,
          receivingDocument: this.receivingDocument,
          receivingDocumentWithOrder: this.receivingDocumentWithOrder,
          releasingDocument: this.releasingDocument,
          releasingDocumentWithOrder: this.releasingDocumentWithOrder,
          transferDocument: this.transferDocument,
          orderSource: this.orderSource,
          customerReturn: this.customerReturn
        };

        this.diffSettings = [];

        // Loop through initial settings to find differences
        for (const key in this.initialSettings) {
          this.spinMessage = "Validatingg & Checking Config: " + key.substring(1)
          console.log("Checking Key: " + key )
          if (!Object.prototype.hasOwnProperty.call(this.initialSettings, key)) continue;

          const initialValue = this.initialSettings[key];
          const newValue = this.logSettings[key.substring(1)];

          if (typeof initialValue === "object" && initialValue !== null) {
            // Deep object comparison
            const objectDiff = this.getComparison(initialValue, newValue);
            console.log(">> objectDiff")
            console.log(objectDiff)
            if (Object.keys(objectDiff).length > 0) {
              for (const diffKey in objectDiff) {
                if (Object.prototype.hasOwnProperty.call(objectDiff, diffKey) && objectDiff[diffKey] != null) {

                  console.log("Create history: " + diffKey)
                  console.log(objectDiff[diffKey])

                  const payload = {
                    config: key.substring(1),
                    config_type: diffKey.substring(1),
                    config_from: initialValue[diffKey],
                    config_to: objectDiff[diffKey],
                    config_at: moment(new Date()),
                    config_by: secureStorage.getItem("userName"),
                    config_account: secureStorage.getItem("accountId"),
                    document_type: this.currentDocumentTypeId
                  };
                  await HTTPRequest.postRequest(
                    this.endPoint + "document_configuration_histories/",
                    null,
                    payload
                  );
                }
              }
            }
          } else {
            // Primitive comparison
            if (initialValue !== newValue) {
              const payload = {
                config: key.substring(1),
                config_type: key.substring(1),
                config_from: initialValue,
                config_to: newValue,
                config_at: moment(new Date()),
                config_by: secureStorage.getItem("userName"),
                config_account: secureStorage.getItem("accountId"),
                document_type: this.currentDocumentTypeId
              };
              await HTTPRequest.postRequest(
                this.endPoint + "document_configuration_histories/",
                null,
                payload
              );
            }
          }
        }
      },

      pushInitSettings(objSettings){
        var myStringArray = Object.keys(objSettings);
        var arrayLength = myStringArray.length;
        var keysMap = {}
        for (var i = 0; i < arrayLength; i++) {
            keysMap[myStringArray[i]] = 'u' + myStringArray[i];
        }
        return this.renameKeys(keysMap, objSettings)
      },
      renameKeys(keysMap, obj){
        return Object.keys(obj).reduce((acc, key) => {
          const renamedObject = {
            [keysMap[key] || key]: obj[key]
          };
          return {
            ...acc,
            ...renamedObject
          };
        }, {});
      },
      async save() {
        this.spinning = true
 
        //Maximum of 200 CSV import for OTHPCN (Physical Count)
        if(this.currentDocumentTypeCode == 'OTHPCN' && this.editorBehavior.maxMassUploadLineRestrictionInput > 2000){
          this.$notification['error'](
                {
                    message: "Action Error",
                    description: "Maximum allowed number of item lines in CSV when mass uploading of products for Physical Count is 2000."
                }
            );
          this.spinning = false
          return;
        }
 
        await this.compareMe()
        var documentTypePayload = {
          document_type: {
            name: this.documentName,
            friendly_code: this.documentFriendlyCode,
            priceOrCost: this.priceOrCost,
            references: this.references,
            editorBehavior: this.editorBehavior,
            additionalEditorBehavior: this.additionalEditorBehavior,
            customFields:this.productCustomFieldsSelected,
            additionalEditorBehaviorCheckboxes: this.additionalEditorBehaviorCheckboxes,
            printSettings:this.printSettings
          }
        }
        var outgoingOrderPayload = {outgoingOrder: this.outgoingOrder}
        documentTypePayload = Object.assign(documentTypePayload, outgoingOrderPayload)
        var incomingOrderPayload = {incomingOrder: this.incomingOrder}
        documentTypePayload = Object.assign(documentTypePayload, incomingOrderPayload)
        var receivingDocumentPayload = {receivingDocument: this.receivingDocument}
        var receivingDocumentWithOrderPayload = {receivingDocumentWithOrder: this.receivingDocumentWithOrder}
        documentTypePayload = Object.assign(documentTypePayload, receivingDocumentPayload)
        documentTypePayload = Object.assign(documentTypePayload, receivingDocumentWithOrderPayload)
        var releasingDocumentPayload = {releasingDocument: this.releasingDocument}
        documentTypePayload = Object.assign(documentTypePayload, releasingDocumentPayload)
        var releasingDocumentWithOrderPayload = {releasingDocumentWithOrder: this.releasingDocumentWithOrder}
        var transferDocumentPayload = {transferDocument: this.transferDocument}
        documentTypePayload = Object.assign(documentTypePayload, releasingDocumentWithOrderPayload)
        documentTypePayload = Object.assign(documentTypePayload, transferDocumentPayload)
        var orderSourcePayload = {orderSource: this.orderSource}
        documentTypePayload = Object.assign(documentTypePayload, orderSourcePayload)
        var customerReturnPayload = {customerReturn: this.customerReturn}
        documentTypePayload = Object.assign(documentTypePayload, customerReturnPayload)
 
        var user_setting_payload = {"module_name": "ORISOX", "settings_json" : {"isSourceMode": this.orderSource.enableOrderSourceMode}}

        if(this.showOrderSourceMode && this.orderSource!=undefined){
          var post_request = await HTTPRequest.postRequest(this.endPoint + 'user_settings/save_order_source', null, user_setting_payload)
        }

        var put_request = await HTTPRequest.putRequest(this.endPoint + 'document_types/save_document_type_settings?id=' + this.currentDocumentTypeId, null, documentTypePayload)
        this.create_action_history("Update")
        if(put_request == undefined){
            this.$emit('refreshPage', event)
            this.$notification['success'](
                {
                    message: "Action successful",
                    description: "Please refresh page for changes to take effect."
                }
            );
        } else {
            if(put_request["error"] == undefined){
                this.$emit('refreshPage', event)
                this.$notification['success'](
                  {
                      message: "Action successful",
                      description: "Please refresh page for changes to take effect."
                  }
                );
            } else {
                //this.errors = put_request["error"].split(",");
            }
        }
        this.spinning = false
      },
      checkAutocreationOfSI(value,action){
        if (action=="create" && value)
          this.additionalEditorBehaviorCheckboxes.autoCreateAndPostSalesInvoiceOnPosting = false;
        else if (action=="create&post" && value)
          this.additionalEditorBehaviorCheckboxes.autoCreateSalesInvoiceOnPosting = false;
      },
      checkAutocreationOfDD(value,action){
        if (action=="DD" && value)
          this.additionalEditorBehaviorCheckboxes.autoCreatePostDDAndSI = false;
        else if (action=="DD&SI" && value)
          this.additionalEditorBehaviorCheckboxes.autoCreatePostDD = false;
      }
    }
  }
</script>

<style>
</style>
